<template lang="pug">
.online-reservation-setting-example-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer scrollable)
    template(#modal-header="{ cancel }")
      .online-reservation-setting-example-modal-header
        span オンライン面会の基本設定の設定例
      button.close(type="button" @click="cancel") ×

    .online-reservation-setting-example-modal-body
      span.title 施設での運用やルールなどに合わせて設定してください。
      ul.detail-item
        li
          span.item 予約時間単位
          span ：15分間隔で予約を受けたい場合、
          span.item 15分
          span を選択してください。
        li
          span.item 家族ユーザーの予約可能日
          span ：１週間後以降の予約しか出来ないようにしたい場合、
          span.item １週間後から
          span を選択してください。
        li
          span.item 利用者ごとの予約間隔制限
          span ：同じ家族が３週間空けないと予約出来ないようにしたい場合、
          span.item ３週間
          span を選択してください。
        li
          span.item 利用者ごとの同時に予約可能な面会数
          span ：同じ家族が面会終了しないと次の面会予約が出来ないようにしたい場合、
          span.item 1件
          span を選択してください。
      span.title オンライン面会の対応職員数やタブレット台数などに合わせて設定してください。
      ul
        li
          span.case 設定例①
          span ：
          span.item 施設全体
          span で同じ
          span.item 面会日程
          span 、
          span.item 施設全体
          span で同時に
          span.item ３件
          span のオンライン面会
        li
          span.case 設定例②
          span ：
          span.item フロアごと
          span に異なる
          span.item 面会日程
          span 、
          span.item 施設全体
          span で同時に
          span.item ２件
          span のオンライン面会
        li
          span.case 設定例③
          span ：
          span.item フロアごと
          span に異なる
          span.item 面会日程
          span 、
          span.item フロアごと
          span に同時に
          span.item １件
          span のオンライン面会
      b-img.image(src="@/assets/online-reservation-setting-example.png" fluid)
      span 設定例②③の場合は、事前にフロアごとに利用者グループを作成し、各利用者を各利用者グループに所属させてください。
      br
      span 設定等でお困りの場合は、お問い合わせ機能からご相談ください。
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * オンライン面会の基本設定の使用例モーダル
 */
@Component
export default class OnlineReservationSettingExampleModal extends Vue {
  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }
}
</script>
